<template>
<div v-if="info.nid === '27'" class="">
    <!-- Map -->
    <section class="mapsec py-0">
        <iframe :src="iframeUrl" width="100%" height="350" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
    </section>
    <!-- End Map -->

    <!-- Contact -->
    <section class="contactdetailsec py-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-9 mb-5 mb-lg-0">
                    <div class="row">
                        <div class="col-12 col-md-12 mb-4">
                            <div class="heading">
                                <h3>Contact Details</h3>
                                <hr class="brd-primary ml-0">
                            </div>
                        </div>
                    </div>
                    <div v-html="info.field_contact_details"></div>
                    <div v-html="info.field_global_contacts"></div>
                    <div class="row no-gutters detailrow">
                        <div class="col-12 col-md-6 col-lg-3">
                            <div class="contact-block text-center">
                                <div class="contact-icon rounded-50 mx-auto mb-3">
                                    <i class="fa fa-map-marker"></i>
                                </div>
                                <div class="contact-txt text-dark">
                                    <span>13 A Powell Rd, Waterfalls, Harare, Zimbabwe</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3">
                            <div class="contact-block text-center">
                                <div class="contact-icon rounded-50 mx-auto mb-3">
                                    <i class="fa fa-phone"></i>
                                </div>
                                <div class="contact-txt text-dark">
                                    <span><a href="tel:+263 8677 004035" class="text-dark">+263 8677 004035</a></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3">
                            <div class="contact-block text-center">
                                <div class="contact-icon rounded-50 mx-auto mb-3">
                                    <i class="fa fa-fax"></i>
                                </div>
                                <div class="contact-txt text-dark">
                                    <span><a href="tel:+44(0)208 997 2725" class="text-dark">+44(0)208 997 2725</a></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3">
                            <div class="contact-block text-center">
                                <div class="contact-icon rounded-50 mx-auto mb-3">
                                    <i class="fa fa-envelope"></i>
                                </div>
                                <div class="contact-txt text-dark">
                                    <span><a href="mailto:info@fifmi.org" class="text-dark">info@fifmi.org</a></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3">
                            <div class="contact-block text-center">
                                <div class="contact-icon rounded-50 mx-auto mb-3">
                                    <i class="fa fa-map-marker"></i>
                                </div>
                                <div class="contact-txt text-dark">
                                    <span>UK/European Headquarters 58 Hainge Road | Tividale, Oldbury | West Midlands | UK | B69 2PB</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3">
                            <div class="contact-block text-center">
                                <div class="contact-icon rounded-50 mx-auto mb-3">
                                    <i class="fa fa-phone"></i>
                                </div>
                                <div class="contact-txt text-dark">
                                    <span><a href="tel:+44(0)121 557 6508" class="text-dark">+44(0)121 557 6508</a></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3">
                            <div class="contact-block text-center">
                                <div class="contact-icon rounded-50 mx-auto mb-3">
                                    <i class="fa fa-fax"></i>
                                </div>
                                <div class="contact-txt text-dark">
                                    <span><a href="tel:+44(0)208 997 2725" class="text-dark">+44(0)208 997 2725</a></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3">
                            <div class="contact-block text-center">
                                <div class="contact-icon rounded-50 mx-auto mb-3">
                                    <i class="fa fa-envelope"></i>
                                </div>
                                <div class="contact-txt text-dark">
                                    <span><a href="mailto:info@fifmi.org" class="text-dark">info@fifmi.org</a></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-12 col-md-12 mb-4">
                            <div class="heading">
                                <h3>Send Us A Message</h3>
                                <hr class="brd-primary ml-0">
                            </div>
                        </div>
                    </div>
                    <form class="contact-form">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label class="text-dark">First Name</label>
                                    <input type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label class="text-dark">Last Name</label>
                                    <input type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label class="text-dark">Email Address</label>
                                    <input type="email" class="form-control">
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label class="text-dark">Address</label>
                                    <input type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label class="text-dark">Phone Number</label>
                                    <input type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label class="text-dark">City</label>
                                    <input type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label class="text-dark">State / Province</label>
                                    <input type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label class="text-dark">Country</label>
                                    <input type="text" class="form-control">
                                </div>
                            </div>
                            <div class="col-12 col-md-12">
                                <div class="form-group">
                                    <label class="text-dark">Select Category</label>
                                    <select class="form-control">
                                        <option value="General">General</option>
                                        <option value="General">General</option>
                                        <option value="General">General</option>
                                        <option value="General">General</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12 col-md-12">
                                <div class="form-group">
                                    <label class="text-dark">Message</label>
                                    <textarea class="form-control"></textarea>
                                </div>
                            </div>
                            <div class="col-12 col-md-12">
                                <button type="submit" class="btn btn-primary btn-lg rounded-0 text-uppercase">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-12 col-lg-3">
                    <!-- Start SideBarExtras -->
                    <SideBarExtras />
                    <hr>
                    <!-- Start Latest News Sidebar -->
                    <LatestNews />
                    <!-- End Latest News Sidebar -->
                </div>
            </div>

        </div>
    </section>
    <!-- End Contact -->
</div>
</template>

<script>
import axios from 'axios';
import LatestNews from "../components/LatestNews";
import SideBarExtras from "../components/SideBarExtras";

export default{
    name: 'Contact',
    components:{
        // eslint-disable-next-line vue/no-unused-components
        LatestNews, SideBarExtras
    },
    data () {
        return {
            info: null
        }
    },
    computed: {
      iframeUrl: function () {
        return 'https://www.google.com/maps?coord='+this.info.field_map_address+','+this.info.field_map_address_1+'&q="5-7 Swettenham Rd, Minto NSW 2566"&z=15&output=embed';
        }
    },
    mounted () {
        axios
        .get('https://api.fifmi.org.au/api/contact')
        .then(result => {
            for (var i = 0; i < result.data.length; i++) {
                if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].nid == 27){
                    this.info = result.data[i];
                }
            }
        });
    }
}
</script>
